<!--
Author: TangChen
Date: 2018-11-21
Desc: 基金超市
 -->
<template>
    <div :class="'bizcomp-change-fund-list bizcomp ' + className">
        <comp-title :title="title" />
        <el-row style="padding: 10px 20px;">
            <asset-fund :fund-info="fund" type="1" v-on:fund-continue="fundChange" />
        </el-row>
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import assetFund from "@/components/fund/assetFund";
export default {
    name: "ChangeFundList",
    components: {
        assetFund
    },
    mixins: [mixin],
    data () {
        return {
            fund: [],
            noFundMsg: "您还没有持有可以转化的基金！"
        };
    },
    created () {
        this.getChangeFund();
    },
    methods: {
        fundChange (way, val) {
            const _fund = this.$util.dataTaacFilter(val);
            const _x = Object.assign({}, _fund, { way: way });
            sessionStorage.setItem("changefund", JSON.stringify(_x));
            this.$router.push({ name: "changefund", query: { fundcode: _fund.fundcode } });
        },
        // 获取可以转换基金列表信息
        getChangeFund () {
            const _this = this;
            this.$util.request("acct/asset/detail").then(res => {
                if (res.data) {
                    const _x = res.data[0];
                    let newArr = [];
                    _x.forEach(item => {
                        if (item.busitype !== "1" && item.availablevol > 0) {
                            newArr.push(item);
                        }
                    });
                    _this.fund = _this.$util.getCodeOnly(newArr, { code: "fundcode", data: ["marketvalue", "costmoney", "floatprofit", "appamount", "availablevol", "frozenvol", "balancevol"] });
                }
            }).catch(() => { });
        }
    }
};
</script>
